import React, { createContext, useContext, useMemo } from "react";
import { SERVICE_CONTEXT_CONFIG } from "./serviceContextConfig";

const ServiceContext = createContext(null);

// Always pass `service` explicitly (e.g. <ServiceProvider service={SERVICES.MY_BUSINESS}>) —
// never derive it from route.serviceKey or any other ambient source. See serviceConstants.js.
export const ServiceProvider = ({ service, children }) => {
  const value = useMemo(() => {
    const config = SERVICE_CONTEXT_CONFIG[service];
    if (!config) {
      throw new Error(`ServiceProvider: no config found for service "${service}"`);
    }
    return { ...config, service };
  }, [service]);

  return <ServiceContext.Provider value={value}>{children}</ServiceContext.Provider>;
};

export const useServiceContext = () => {
  const context = useContext(ServiceContext);
  if (!context) {
    throw new Error("useServiceContext must be used within a ServiceProvider");
  }
  return context;
};

// Non-throwing variant for hooks (e.g. usePermission) that run both inside
// service routes (/myFpo, /mybusiness) and outside them (admin/platform pages) —
// returns null instead of throwing when there's no enclosing ServiceProvider.
export const useOptionalServiceContext = () => useContext(ServiceContext);
